<template>
  <KTCard data-cy="role-add-page">
    <RoleForm ref="roleForm" :roles="roles" @submitForm="onSubmitForm" />

    <template v-slot:footer>
      <div class="d-flex justify-content-start">
        <ButtonElement
          data-cy="submit-btn"
          variant="primary"
          text="save"
          class="mr-3"
          @click="onClickSubmit"
        />

        <ButtonElement data-cy="back-btn" variant="text-primary" text="back" @click="onClickBack" />
      </div>
    </template>
  </KTCard>
</template>

<script>
import apolloMixin from "@/mixins/apollo.mixin";
import { roleList } from "./gql/queries";
import { createRole } from "./gql/mutations";

import KTCard from "@/components/card/KTCard";
import RoleForm from "../_components/RoleForm";
import ButtonElement from "@/components/ButtonElement";

const CONTENT_WIDTH = 800;

export default {
  name: "RoleAdd",
  components: {
    KTCard,
    RoleForm,
    ButtonElement,
  },

  mixins: [apolloMixin],

  data: () => ({
    roles: [],
  }),

  async created() {
    await this.getRoles();
  },

  mounted() {
    this.$setBreadcrumbs(["RoleList"]);
    this.$setMaxContentWidth(CONTENT_WIDTH);
  },

  beforeDestroy() {
    this.$resetMaxContentWidth();
  },

  methods: {
    async getRoles() {
      const { roles } = await this.$get(roleList);

      this.roles = roles;
    },

    onClickSubmit() {
      this.$refs.roleForm.submitForm();
    },

    async onSubmitForm(roleData) {
      const createdRole = await this.$post(createRole, roleData, {
        delaySuccessNotify: true,
      });

      if (createdRole) await this.$router.push({ name: "RoleList" });
    },

    onClickBack() {
      this.$router.push({ name: "RoleList" });
    },
  },
};
</script>
